import React, { useEffect, useState } from 'react';
import './App.css';

const backgrounds = [
  "/130ave_f_bayonne_front.png",
  "/130ave_f_bayonne_bird.png",
  "/130ave_f_bayonne_top.png"
];

const BACKGROUND_INTERVAL = 5000; //transition in ms

function App() {
  const [currentBackground, setCurrentBackground] = useState(0);

  useEffect(() => {
    const intervalId = setInterval(() => {
        setCurrentBackground((prevBackground) =>
            (prevBackground + 1) % backgrounds.length
        );
    }, BACKGROUND_INTERVAL); // Change background every 5 seconds

    return () => clearInterval(intervalId); // Cleanup on unmount
  }, []);

  return (
      <div className="container" style={{ backgroundImage: `url(${backgrounds[currentBackground]})` }}>
        <div className="logo-container">
            <img src="/rivcon_logo2.png" alt="Company Logo" className="logo" />
        </div>

        <div className="text-box">
          <h1 className="heading">We're working on something great!</h1>
          <p className="subheading">This site is currently under construction. Check back soon!</p>
        </div>

        <div className="contact-box">
          <p>Contact Us:</p>
          <p>Email: bidding@rivcon.org</p>
          <p>Phone: +1 (732) 962-8053</p>
        </div>
    </div>
  );
}

export default App;